import React from 'react';
import Drawer from '../../Drawer/Drawer';
import DrawerNavTemplate from '../../../templates/DrawerNavTemplate/DrawerNavTemplate';
import DrawerHeaderFormPage from '../../../pages/Drawer/Header/Form/DrawerHeaderForm';
import DrawerFooterFormPage from '../../../pages/Drawer/Footer/DrawerFooter';

import PropTypes from 'prop-types';
import {
  PATH_SETTINGS_FORM,
  PATH_EDITFIELDS_FORM,
  PATH_DATA_FORM,
  PATH_INFO_FORM,
  PATH_BLOCKS_FORM,
  PATH_QUALITY_FORM,
  PATH_RESPONDANTS_FORM,
  PATH_STRATEGY_FORM,
  PATH_FIELD_NO_COMPARE,
  PATH_FIELD_TO_COMPARE,
  PATH_BLOCKS_SORTING,
  PATH_KEYBOARD_SHORTCUTS,
  PATH_VALIDATION_FORM,
  PATH_ADVANCED_FIELD_TO_COMPARE,
  PATH_ITERATION_OVERLOAD,
} from '../../../../constants/paths';
import DrawerContentItemsPage from '../../../pages/Drawer/Content/Items/DrawerContentItems';
import DrawerContentSettingsPage from '../../../pages/Drawer/Content/Settings/DrawerContentSettings';
import DrawerContentInfo from '../../../pages/Drawer/Content/Info/DrawerContentInfo';
import DrawerContentBlocks from '../../../pages/Drawer/Content/Blocks/DrawerContentBlocks';
import DrawerContentQualityPage from '../../../pages/Drawer/Content/Quality/DrawerContentQuality';
import DrawerContentRespondantsPage from '../../../pages/Drawer/Content/Quality/Respondants/DrawerContentRespondants';
import DrawerContentStrategyPage from '../../../pages/Drawer/Content/Quality/Strategy/DrawerContentStrategy';
import DrawerContentValidation from '../../../pages/Drawer/Content/Validation/DrawerContentValidation';
import DrawerContentNoComparePage from '../../../pages/Drawer/Content/Quality/NoCompare/DrawerContentNoComparePage';
import DrawerContentToComparePage from '../../../pages/Drawer/Content/Quality/ToCompare/DrawerContentToCompare';
import DrawerContentBlocksSortingPage from '../../../pages/Drawer/Content/Quality/BlocksSorting/DrawerContentBlocksSorting';
import DrawerContentKeyboardShortcuts from '../../../pages/Drawer/Content/KeyboardShortcuts/KeyboardShortcuts';
import AdvancedToComparePage from '../../../pages/Drawer/Content/Quality/AdvancedToCompare/AdvancedToCompare';
import DrawerIterationOverload from '../../../pages/Drawer/Content/Quality/IterationOverload/IterationOverload';

const CONTENT_BY_PATH = {
  [PATH_EDITFIELDS_FORM]: DrawerContentItemsPage,
  [PATH_DATA_FORM]: DrawerContentItemsPage,
  [PATH_BLOCKS_FORM]: DrawerContentBlocks,
  [PATH_INFO_FORM]: DrawerContentInfo,
  [PATH_QUALITY_FORM]: DrawerContentQualityPage,
  [PATH_RESPONDANTS_FORM]: DrawerContentRespondantsPage,
  [PATH_STRATEGY_FORM]: DrawerContentStrategyPage,
  [PATH_SETTINGS_FORM]: DrawerContentSettingsPage,
  [PATH_VALIDATION_FORM]: DrawerContentValidation,
  [PATH_FIELD_NO_COMPARE]: DrawerContentNoComparePage,
  [PATH_FIELD_TO_COMPARE]: DrawerContentToComparePage,
  [PATH_BLOCKS_SORTING]: DrawerContentBlocksSortingPage,
  [PATH_KEYBOARD_SHORTCUTS]: DrawerContentKeyboardShortcuts,
  [PATH_ADVANCED_FIELD_TO_COMPARE]: AdvancedToComparePage,
  [PATH_ITERATION_OVERLOAD]: DrawerIterationOverload,
};

const AppDrawer = ({ path }) => {
  const ContentPage = CONTENT_BY_PATH[path];

  return (
    <Drawer hasFixedPosition={false}>
      <DrawerNavTemplate path={path} />
      <Drawer.Body>
        <Drawer.Header>
          <DrawerHeaderFormPage />
        </Drawer.Header>
        <Drawer.Content>{ContentPage && <ContentPage path={path} />}</Drawer.Content>
        <Drawer.Footer>
          <DrawerFooterFormPage />
        </Drawer.Footer>
      </Drawer.Body>
    </Drawer>
  );
};

AppDrawer.propTypes = {
  path: PropTypes.string,
};

export default AppDrawer;
